import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import CreateProgrammeForm from "../Forms/CreateProgrammeForm";
class CreateProgramme extends React.Component {
  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} size="lg">
        <ModalHeader toggle={this.props.toggle}>
          <div>
            <span className="fa fa-plus-circle" /> Skapa program
          </div>
        </ModalHeader>
        <ModalBody>
          <CreateProgrammeForm
            refreshProgrammes={this.props.onComplete}
            school={this.props.school}
            dismissModal={this.props.toggle}
            fortNoxPrograms={this.props.fortNoxPrograms}
          />
        </ModalBody>
      </Modal>
    );
  }
}

export default CreateProgramme;
